// extracted by mini-css-extract-plugin
export default {"payment-method-option":"styles_payment-method-option__DIcyk","paymentMethodOption":"styles_payment-method-option__DIcyk"};